import format from "date-fns/format";

import { Calendar } from "@livechat/design-system-icons";

import { CustomDateRangeFilterId, Filter, IDateRangeFilter } from "constants/filters";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

const labelsMap = {
  [CustomDateRangeFilterId.Today]: "First response today",
  [CustomDateRangeFilterId.Yesterday]: "First response yesterday",
  [CustomDateRangeFilterId.Last7Days]: "First response in last 7 days",
  [CustomDateRangeFilterId.LastMonth]: "First response last month",
};

export const responseDateRangeFilterConfig: IFilterConfig = {
  title: "First response date",
  multiple: false,
  icon: Calendar,
  getFilterLabelValues: (filterValues: IDateRangeFilter): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    const label =
      // @ts-expect-error TS(7053)
      labelsMap[filterValues.id] ||
      // @ts-expect-error TS(2345)
      `First response: ${format(filterValues.from, "YYYY-MM-DD")} – ${format(filterValues.to, "YYYY-MM-DD")}`;

    return [
      {
        key: Filter.ResponseDateRange,
        label,
      },
    ];
  },
};
